// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

.footer-section {
  background: linear-gradient(to bottom, #e3e4ff 80%, #8084ff 100%);
  position: relative;
}

.footer-address-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
}

.footer-address-section ul {
  text-decoration: none;
  list-style: none;
  margin-bottom: 2rem;
}

.footer-route-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-route-list li {
  list-style: none;
  text-decoration: none;
}

.footer-route-list a {
  text-decoration: none;
  color: black;
  font-size: 15px;
}

.footer-route-list a:hover {
  text-decoration: underline;
}

.footer-container {
  gap: 22px;
  display: flex;
  padding: 50px 0 0 0;
  justify-content: space-between;
}

.footer-left-container {
  flex: 1 1 100%;
  padding-left: 20px;
}

.footer-left-container img {
  width: 100%;
  max-width: 180px;
  margin-bottom: 1.2rem;
  transition: 0.3s linear;
}

.footer-left-container img:hover {
  transform: scale(1.1);
}

.footer-left-container p {
  width: 100%;
  max-width: 450px;
}

.footer-left-container button {
  border: none;
  overflow: none;
  font-size: 18px;
  cursor: pointer;
  border-radius: 12px;
  padding: 15px 2.5rem;
  transition: 0.3s linear;
  color: var(--primary-white);
  background-color: var(--primary-blue);
}

.footer-left-container button:hover {
  transform: translateY(-5px);
  background-color: #555ae6;
  box-shadow: 1px 1px 10px #6d72f6;
}

.footer-left-nav-box {
  gap: 5px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 60px;
  justify-content: space-evenly;
}

.footer-left-nav-box a {
  font-size: 16px;
  text-decoration: none;
  color: var(--primary-black);
}

.footer-left-nav-box a:hover {
  color: var(--primary-blue);
}

.footer-right-container {
  width: 100%;
  height: 390px;
  padding: 45px 5.5rem;
  border-top: 2px solid;
  border-left: 2px solid;
  border-top-left-radius: 6rem;
  border-color: var(--primary-blue);
  background-color: rgba(230, 243, 250, 0.41);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;
  position: relative;
}

.footer-right-top-box {
  gap: 22px;
  display: flex;
  justify-content: space-between;
}

.footer-right-box h3 {
  font-size: 18px;
  color: var(--primary-blue);
}

.footer-right-box h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 400;
  color: #4c4c4c;
}

.footer-right-icon-box {
  display: flex;
  gap: 8px;
  margin-top: 1rem;
}

.footer-right-icon-box svg {
  width: 40px;
  height: 40px;
  padding: 10px;
  border-radius: 50%;
  color: var(--primary-white);
  border: 1px solid #dddddd;
  background-color: var(--primary-blue);
  transition: background-color 0.3s, transform 0.3s;
}

.footer-right-icon-box svg:hover {
  transform: scale(1.2);
  color: var(--primary-black);
  border-color: var(--primary-white);
  box-shadow: 0px 2px 10px #7272726c;
  background-color: var(--primary-white);
}

.footer-right-bottom-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-right-bottom-box p {
  color: var(--primary-black2);
}

.footer-scroll-btn {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  cursor: pointer;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  color: var(--primary-white);
  background: transparent;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.footer-scroll-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border-top: 2px solid var(--primary-blue);
  border-right: 2px solid var(--primary-blue);
  animation: border-rotate 1.5s linear infinite;
  background: linear-gradient(
    135deg,
    var(--primary-blue),
    var(--primary-purple)
  );
}

.footer-scroll-btn:hover {
  color: var(--primary-white);
  background: var(--primary-blue);
  box-shadow: 0 0 15px var(--primary-blue);
}

.footer-scroll-btn svg {
  font-size: 20px;
}

@keyframes border-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.footer-copyright {
  position: absolute;
  bottom: 10px;
  font-size: 14px;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 886px) {
  .footer-right-container {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 1024px) {
  .footer-right-container {
    padding: 45px 3rem;
  }
  .footer-right-container {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 1280px) {
  .footer-left-container {
    flex: 1 1 50%;
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }
  .footer-right-container {
    gap: 2rem;
    width: 100%;
    height: 100%;
    padding: 40px;
    max-width: 95%;
    margin: 0 auto;
    border-top: 2px solid;
    border-left: 2px solid;
    border-right: 2px solid;
    border-top-left-radius: 6rem;
    border-top-right-radius: 6rem;
    border-color: var(--primary-blue);
  }
  .footer-left-container img {
    width: 100%;
    max-width: 250px;
  }
}

@media (max-width: 480px) {
  .footer-right-top-box {
    flex-direction: column;
  }
  .footer-right-bottom-box,
  .footer-right-icon-box {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,2CAA2C;EAC3C,6CAA6C;EAC7C;;;;GAIC;AACH;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,iCAAiC;EACnC;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n.footer-section {\n  background: linear-gradient(to bottom, #e3e4ff 80%, #8084ff 100%);\n  position: relative;\n}\n\n.footer-address-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 3rem;\n}\n\n.footer-address-section ul {\n  text-decoration: none;\n  list-style: none;\n  margin-bottom: 2rem;\n}\n\n.footer-route-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.footer-route-list li {\n  list-style: none;\n  text-decoration: none;\n}\n\n.footer-route-list a {\n  text-decoration: none;\n  color: black;\n  font-size: 15px;\n}\n\n.footer-route-list a:hover {\n  text-decoration: underline;\n}\n\n.footer-container {\n  gap: 22px;\n  display: flex;\n  padding: 50px 0 0 0;\n  justify-content: space-between;\n}\n\n.footer-left-container {\n  flex: 1 1 100%;\n  padding-left: 20px;\n}\n\n.footer-left-container img {\n  width: 100%;\n  max-width: 180px;\n  margin-bottom: 1.2rem;\n  transition: 0.3s linear;\n}\n\n.footer-left-container img:hover {\n  transform: scale(1.1);\n}\n\n.footer-left-container p {\n  width: 100%;\n  max-width: 450px;\n}\n\n.footer-left-container button {\n  border: none;\n  overflow: none;\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 12px;\n  padding: 15px 2.5rem;\n  transition: 0.3s linear;\n  color: var(--primary-white);\n  background-color: var(--primary-blue);\n}\n\n.footer-left-container button:hover {\n  transform: translateY(-5px);\n  background-color: #555ae6;\n  box-shadow: 1px 1px 10px #6d72f6;\n}\n\n.footer-left-nav-box {\n  gap: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 60px;\n  justify-content: space-evenly;\n}\n\n.footer-left-nav-box a {\n  font-size: 16px;\n  text-decoration: none;\n  color: var(--primary-black);\n}\n\n.footer-left-nav-box a:hover {\n  color: var(--primary-blue);\n}\n\n.footer-right-container {\n  width: 100%;\n  height: 390px;\n  padding: 45px 5.5rem;\n  border-top: 2px solid;\n  border-left: 2px solid;\n  border-top-left-radius: 6rem;\n  border-color: var(--primary-blue);\n  background-color: rgba(230, 243, 250, 0.41);\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 3rem;\n  position: relative;\n}\n\n.footer-right-top-box {\n  gap: 22px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.footer-right-box h3 {\n  font-size: 18px;\n  color: var(--primary-blue);\n}\n\n.footer-right-box h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 400;\n  color: #4c4c4c;\n}\n\n.footer-right-icon-box {\n  display: flex;\n  gap: 8px;\n  margin-top: 1rem;\n}\n\n.footer-right-icon-box svg {\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  border-radius: 50%;\n  color: var(--primary-white);\n  border: 1px solid #dddddd;\n  background-color: var(--primary-blue);\n  transition: background-color 0.3s, transform 0.3s;\n}\n\n.footer-right-icon-box svg:hover {\n  transform: scale(1.2);\n  color: var(--primary-black);\n  border-color: var(--primary-white);\n  box-shadow: 0px 2px 10px #7272726c;\n  background-color: var(--primary-white);\n}\n\n.footer-right-bottom-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.footer-right-bottom-box p {\n  color: var(--primary-black2);\n}\n\n.footer-scroll-btn {\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  cursor: pointer;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-white);\n  background: transparent;\n  transition: background 0.3s ease, box-shadow 0.3s ease;\n}\n\n.footer-scroll-btn::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border-top: 2px solid var(--primary-blue);\n  border-right: 2px solid var(--primary-blue);\n  animation: border-rotate 1.5s linear infinite;\n  background: linear-gradient(\n    135deg,\n    var(--primary-blue),\n    var(--primary-purple)\n  );\n}\n\n.footer-scroll-btn:hover {\n  color: var(--primary-white);\n  background: var(--primary-blue);\n  box-shadow: 0 0 15px var(--primary-blue);\n}\n\n.footer-scroll-btn svg {\n  font-size: 20px;\n}\n\n@keyframes border-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.footer-copyright {\n  position: absolute;\n  bottom: 10px;\n  font-size: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n@media (max-width: 886px) {\n  .footer-right-container {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .footer-right-container {\n    padding: 45px 3rem;\n  }\n  .footer-right-container {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@media (max-width: 1280px) {\n  .footer-left-container {\n    flex: 1 1 50%;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n  }\n  .footer-right-container {\n    gap: 2rem;\n    width: 100%;\n    height: 100%;\n    padding: 40px;\n    max-width: 95%;\n    margin: 0 auto;\n    border-top: 2px solid;\n    border-left: 2px solid;\n    border-right: 2px solid;\n    border-top-left-radius: 6rem;\n    border-top-right-radius: 6rem;\n    border-color: var(--primary-blue);\n  }\n  .footer-left-container img {\n    width: 100%;\n    max-width: 250px;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-right-top-box {\n    flex-direction: column;\n  }\n  .footer-right-bottom-box,\n  .footer-right-icon-box {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
